export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ13.9d80fe76.mp3";